const brands = [
  { brandName: "brand", imgPath: "Logos/client/AFRM.png", alt: "AFRM logo" },
  {
    brandName: "brand",
    imgPath: "/Logos/client/Overlooked.png",
    alt: "Overlooked logo",
  },
  { brandName: "brand", imgPath: "/Logos/client/PwC.png", alt: "PwC logo" },
  { brandName: "brand", imgPath: "/Logos/client/SNg.png", alt: "SNg logo" },
];

export default brands;
